<template>
    <div id="ApplicationType" class="app-inner">
            <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addBus(0)">
        新增试卷分类
      </div>
           <div class="businessList_header flex align-cen mft">
            <el-input
            placeholder="分类名称"
            v-model="searchname"
            clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
         <div class="businessList-filter-list flex align-cen public-btn-small" style="padding-left:0">
            <div class="public-btn-small-primary" @click="search">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
     </div>
    </div>
    <div class="ApplicationType-container">
        <div class="ApplicationType-tit flex align-cen">
            <div class="tit ptit">分类</div>
            <div class="tit2 ptit">排序</div>
             <div class="tit3 ptit">操作</div>
        </div>
        <div class="ApplicationType-list" v-if="itemList.length != 0">
            <div v-for="(item,index) in itemList" :key="item.id" class="forlist">
                <div class="isSystem flex align-cen" v-if="item.id == 1">
                    <div class="tit">
                        <p style="color:#000">{{item.name}}</p>
                        <p style="font-size:13px">{{item.remark}}</p>
                    </div>
                    <div class="tit2">{{item.sort}}</div>
                    <div class="tit3" style="color:red">-</div>
                </div>
                <div v-else class="isnone">
                      <el-collapse v-model="activeNames">
                     <el-collapse-item :name="item.id">
                        <template slot="title">
                     
                         <div class="copl flex align-cen">
                            <div class="tit">
                                  <p style="color:#000">{{item.name}}</p>
                            </div>
    
                              <div class="tit2">
                                {{item.sort}}
                              </div>
                               <div class="tit3" style="color:red">
                                <div class="public-btn-small flex align-cen justify-content-cen">
                                    <div class="public-btn-small-text"  @click.stop="addBus(2,item.name,item.sort,item.id,item.parentId)">添加子分类</div>
                                    <div class="public-btn-small-text" v-if="item.id != 2"
                                    @click.stop="addBus(1,item.name,item.sort,item.id,item.parentId,index)"
                                    >编辑</div>
                                    <div class="public-btn-small-dangertext" v-if="item.id != 2"
                                    @click.stop="deletchapter(0,item.id)"
                                    >删除</div>
                                </div>
                               </div>
                         </div>
                        </template>
                        <!-- 子集内容 -->
                        <div class="childrenlist flex align-cen" v-for="(childItem,childItemIndex) in item.children" :key="childItem.id">
                            <div class="tit">
                                {{childItem.name}}
                            </div>
                            <div class="tit1"></div>
                            <div class="tit3">
                                 <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                        <i class="icon-al-edit"  style="color:#409eff"
                                        @click="addBus(3,childItem.name,childItem.sort,childItem.id,childItem.parentId,index,childItemIndex)"
                                        ></i>
                                        </el-tooltip>
                                         <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                        <i class="icon-al-delete-fill" style="color:#F56C6C"
                                         @click.stop="deletchapter(1,childItem.id)"
                                        ></i>
                                        </el-tooltip>
                            </div>
                        </div>
                     </el-collapse-item>
                      </el-collapse>
                </div>
            </div>
        </div>
         <div class="none-chapter" v-else>
                    <i class="icon-al-cry-fill"></i>
                    <p>暂无分类</p>
                </div>
    </div>

  <!-- 增加修改弹窗 -->
     <el-dialog
  :title="tit"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center
  >
       <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在添加中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
       >
         <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="分类名称：" prop="name">
              <el-input v-model="formLabelAlign.name" clearable placeholder="20字以内" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="排序：">
              <el-input v-model.number="formLabelAlign.sort" clearable class="bbb" ></el-input>
        </el-form-item>
    </el-form>
     <div class="btn" @click="onsubmit('ruleForm')">确定</div>
       </div>
     </el-dialog>
    </div>
</template>
<script>
import {listTree,editPaper,delpaperClassify} from "@/api/index/index"  //试卷分类、新增修改试卷分类、删除查询试卷
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import debounce from '../../../utils/debounce.js' //防抖
export default {
    name:'testPaperClass',
    data: () =>{
        return {
            loading:false,
            contype:0,
             headers:{},
                uploadBoolean:false,
                oploadDialogVisible: false,
            tips:'一级分类建议尺寸128*128,21帧竖图，子分类128*128',
            searchname:'',
            itemList:[],
            activeNames:[],
            centerDialogVisible:false,
             edittype:0,
             parentId:'0',
             editid:'',
             tit:'新增试卷分类',
              formLabelAlign:{
                name:'',
                sort:'',
        },
             rules: {
             name: [
             { required: true, message: '请正确填写分类名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ],
        }
        }
    },
      activated(){
  this.gethisInfo()
},
    created(){
         let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        // this.gethisInfo()
    },
    methods: {
         // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
          handleAvatarSuccess(res, file) {
        // this.formLabelAlign.logo = res.data.url
        
        if(this.formLabelAlign.logo){
        this.uploadBoolean = false
         }
      },
        onsubmit(formName){
             this.$refs[formName].validate((valid) => {
                 let method = "post"
                 let params = { ...this.formLabelAlign};
                if(this.edittype == 0) params = {...this.formLabelAlign,parentId:this.parentId},method = "post";
                 if(this.edittype == 1) params = {...this.formLabelAlign,parentId:this.parentId,id:this.editid}, method = "put";  
                if(valid){
                     if(typeof(this.formLabelAlign.sort) == 'string' && this.formLabelAlign.sort != "") return this.$message.error('排序只能输入数字')
                         //防抖提交
                            debounce(() => {
                             this.commentBness(params,method)
                         }, 500)
                      
                }
             })
        },
            commentBness(params,method){
                this.loading = true
                editPaper(params,method)
                        .then(res => {
                            this.loading = false
                           if(res.code == 0){
                            if(this.edittype == 0) this.$message.success('新增成功'); 
                           if(this.edittype == 1) this.$message.success('修改成功'); 
                                this.gethisInfo()
                                this.uploadBoolean = false
                                    setTimeout(() => {
                                this.centerDialogVisible = false
                                }, 100);
                           }else{
                            this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                        })
        },
           // 获取分类
        gethisInfo(){
            listTree({
                name:this.searchname,
            })
            .then(res => {
              if(res.data !==null){
                this.itemList = res.data
                 if(res.data.length !=0){
                     for (const key in res.data) {
                        this.activeNames.push(res.data[key].id)
                    }
                 }
              }else{
                    this.itemList = []
                 }
            })
            .catch(err => {
            })
        },
        // 新增
        addBus(type,name,sort,id,parentId,index,childIndex){
                // type0表示新增，type1表示修改,type2表示新增子应用分类，type3表示修改子应用分类
            switch (type) {
                 case 0:
                  return this.edittype = 0,this.contype = type, this.tit = "新增试卷分类",this.centerDialogVisible = true,this.parentId = '0',this.formLabelAlign = {name:'',sort:''},this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 1:
                  return this.edittype = 1, this.contype = type,this.tit = "修改试卷分类",this.centerDialogVisible = true, this.formLabelAlign.name = name,this.formLabelAlign.sort = sort,this.editid = id,this.parentId = parentId,this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 2:
                  return this.edittype = 0, this.contype = type,this.tit = "新增试卷子分类",this.centerDialogVisible = true,this.formLabelAlign = {name:'',sort:''},this.parentId = id,this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 3:
                return this.edittype = 1, this.contype = type,this.tit = "修改试卷子分类",this.centerDialogVisible = true,this.formLabelAlign.name = name,this.formLabelAlign.sort = sort, this.editid  = id,this.parentId = parentId,this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
            }
        },
    // 删除分类
        deletchapter(type,id){
           this.commdel(type,id)
        },
              commdel(type,id){
            let that = this
            let str = type == 0 ? '确定删除该应用分类，删除后原该分类下的应用将变为“未分类”状态' : '确定要删除该应用分类？删除后原该分类下的应用将归属上级分类状态'
            // let str = '确定删除该应用分类，删除后原该分类下的应用将变为“未分类”状态'
             this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              delpaperClassify({
                id:id
              },'DELETE')
            .then(res => {
                if(res.code == 1){
                    this.$message.error(res.msg)
                }else{
             this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.gethisInfo()
                }

            })
            .catch(err => {
            })
        }).catch(() => {         
        });
        },
        // 搜索
        search(){
            this.gethisInfo()
        },
        // 重置
        reset(){
              this.searchname = ""
            this.gethisInfo()
        },
    }
}
</script>
<style lang="scss" scoped>
#ApplicationType{
        padding: 0 20px;
.businessList_header{
    .el-input{
        width: 200px;
        margin-right: 16px;
        height: 30px;
    }
}
.ApplicationType-container{
    padding: 20px 0;
    .ApplicationType-tit{
        background-color:#f7f7f7;
        padding: 10px 0;
        .ptit{
            text-align: center;
        }
        .tit,.tit3{width: 33%;}
        .tit1,.tit2{width:33%;
        }
    }
    .ApplicationType-list{
        .isSystem{
            margin-top: 16px;
             .tit,.tit3{width: 33%;text-align: center;
             }
        .tit1,.tit2{width: 33%;text-align: center;
                img{
            width: 64px;
            height: 64px;
            border-radius: 50%;
        }
        }
        
        }
        .isnone{
            width: 100%;
            .el-collapse{
                border: none;
            }
            .copl{
                 width: 100%;
        .tit,.tit3{width: 33%;text-align: center;
                     .public-btn-small{
                padding-left: 0;
                font-size: 13px;
             }
              margin: 10px 0;
             
        }
        .tit1,.tit2{width: 33%;text-align: center;
              img{
            width: 64px;
            height: 64px;
            border-radius: 50%;
           
        }
        
        } 
            }
       .childrenlist{
       padding: 0px 0px;
    margin-top: 10px;
    background: #f7f8fa;
    .tit,.tit3{
        text-align: center;
        width: 33%;
         i{
                 margin-right: 10px;
                  font-size: 20px;
                  cursor: pointer;
              }
    }
    .tit1,.tit2{width: 33%;text-align: center;
          img{
            width: 64px;
           height: 64px;
            border-radius: 64px;
        }
    } 
       }
       .childrenlist:first-child{
        margin-top: 30px;
       }
        }
    }
       .none-chapter{
            text-align: center;
            padding-top: 100px;
            i{
                font-size: 50px;
               
            }
          }
}
}
.forminfo{
     .btn{
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
     .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 60px;
    height: 60px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
             .el-input__inner{
            height: 30px !important;
            line-height: 30px !important;
        }
        .el-input__icon{
            line-height: 30px;
        }
         .el-collapse-item__wrap{
        border-bottom: none;
    }
                .el-collapse-item__header{
                 border: none;
            }
                 .el-collapse-item__arrow{
                    position: absolute;
                    left: 5%;
                    font-weight: bold;
                    
                }
}
</style>